<template>
  <el-container class="indexbox">
    <el-header class="header-box" style="height: 73px">
      <div class="head">
        <!-- <div style="display: flex;justify-content: center;align-items: center;">
          <div class="head-logo">
            <img src="@/assets/logo_new.png" class="pointer" @click="handleHome"/>
          </div>
          <div class="head-menu">
            <el-menu
              :default-active="$route.path"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleSelect"
              text-color="#1d2326"
              active-text-color="#ffffff">
              <el-menu-item index="1" v-for="(item,index) of menus" :key="'menus' + index" :index="item.path" v-if="item.isShow">
                <router-link :to="item.path">{{item.meta.title}}</router-link>
              </el-menu-item>
            </el-menu>
          </div>
        </div> -->
        <el-row class="headRow">
          <el-col :span="3">
            <div class="head-logo">
              <img src="@/assets/logo_new2.png" class="pointer" @click="handleHome"/>
            </div>
          </el-col>
          <el-col :span="19">
            <div class="head-menu nav-menu">
              <el-menu
                :default-active="$route.path"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
                text-color="#1d2326"
                active-text-color="#ffffff">
                <el-menu-item index="1" v-for="(item,index) of menus" :key="'menus' + index" :index="item.path" v-if="item.isShow">
                  <router-link :to="item.path">{{item.meta.title}}</router-link>
                </el-menu-item>
              </el-menu>
            </div>
            <!-- <input type="checkbox" id="nav-toggle" class="nav-toggle"> -->
            <!-- <label for="nav-toggle" class="nav-toggle-label">☰</label> -->
            <el-dropdown for="nav-toggle" class="nav-toggle-label">
              <span class="el-dropdown-link">
                ☰<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item,index) of menus" :key="'menus' + index" :index="item.path" v-if="item.isShow">
                  <router-link :to="item.path">{{item.meta.title}}</router-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </div>
    </el-header>
    <el-container class="contentsbox mt20">
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
    <div class="footer-box">
      <!-- <div class="mt15">
        SLOT A multiomics dataset of acute infections
      </div> -->
      <div class="mt10">
        Copyright© 2025 The π-HuB Consortium. All Right Reserved.
      </div>
    </div>
  </el-container>
</template>

<script>
  import {  } from '@/api'
  import {menus} from '../router/menus'
  import ElFooter from "../../node_modules/element-ui/packages/footer/src/main";
  export default {
    components: {ElFooter},
    name: 'home',
    data() {
      return {
        menus: menus,
        input3: '',
        select: '',
        activeIndex: '/',
        blackList: [],
        islogin: false,
        username: '',
        isAdmin: false,
        menuStyle: {
          backgroundImage: 'linear-gradient(to right, #00458C 0, #930000 100%)'
        }
      };
    },
    computed: {},
    mounted() {
      const navMenu = document.querySelector('.head-menu');

      // 监听窗口大小变化，自动调整导航栏
      window.addEventListener('resize', () => {
        if (window.innerWidth <= 1023) {
          navMenu.style.display = "none"; 
        }
      });
    },
    created() {
      this.activeIndex = this.$route.path
      // let logindata = JSON.parse(window.localStorage.getItem('logindata'))
      // if(logindata) {
      //   this.islogin = true
      //   this.username = logindata.userName
      // }
      console.log(this.$store)
      this.islogin = this.$store.state.loginFlag
      this.username = this.$store.state.userInfo.userName
      if(this.$store.state.isUserAdmin) {
        this.isAdmin = true
      } else {
        this.isAdmin = false
      }
//      getUserByToken().then((res) => {
//        console.log(res)
//        this.islogin = true
//        this.username = res.data.userName
//        this.$store.commit('setUserInfo',res.data)
//        this.$store.commit('setLoginFlag',true)
////        if(res.data.userType = '8') {
////          this.isAdmin = true
////        } else {
////          this.isAdmin = false
////        }
//      })
      // console.log(logindata)
    },
    watch: {},
    methods: {
      handleLogin() {
        this.$router.push({path: '/login'})
      },
      handleRegister() {
        this.$router.push({path: '/register'})
      },
      handleHome() {
        this.$router.push({path: '/'})
      },
      handleSelect(index,indexPath) {
        // console.log(index,indexPath)
        this.$router.push({path: index})
      },
      handleLogout() {
        this.$store.commit('setToken','')
        this.$store.commit('setUserInfo', '')
        this.$store.commit('setLoginFlag', false)
        this.$store.commit('setIsAdmin', false)
        this.$store.commit('setIsRemAdmin', false);
        this.$store.commit('setIsUserAdmin', false);
        window.localStorage.clear()
        window.location.reload()
        this.$message({
          message: '退出成功',
          type: 'success'
        });
        this.$router.push({path: '/login'})
      },
      handleContactus() {
        this.$router.push({path: '/contactus'})
      },
      handleMessage() {
        this.$router.push({path: '/message'})
      },
      handleUserm() {
        this.$router.push({path: '/usermanage'})
      },
      handleRecommen() {
        this.$router.push({path: '/recommen'})
      },
      handleUserI () {
        this.$router.push({path: '/userinformation'})
      }
    },
  };
</script>
<style lang="scss" scoped>
  .indexbox {
    height: 100%;
    /*padding-top: 72px;*/
    .contentsbox {
      margin-top: 72px;
      // width: 80%;
      width: 100%;
      // padding-right: 15px;
      // padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
    }
  }
  .head {
    // background:#1a6a24;
    background: #D8E9F1;
    border-bottom: 5px solid #1C7DA6;
    height: 73px;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // background: #F2F5F8;
    
    // background: linear-gradient(to right, #00458C 0, #930000 100%) !important;
    // border-image: linear-gradient(to right, #706ee7, #00c4c4, #706ee7 100%) 1;
    // border-bottom: 5px solid;
  }
  .el-menu-demo {
    // background-color: transparent !important;
    background-color: #9BD2EC !important;
  }
  ::v-deep .el-menu-item:hover {
    color: #03587d !important; /* 修改为你想要的鼠标悬浮颜色 */
  }
  .head-logo {
    img {
      // height:44px;
      height: 73px;
      // width: 320px;
      // margin-left: 15px;
      // margin-right: 50px;
      // margin-left: 34px;
      // margin-right: 30px;
      vertical-align: middle;
    }
  }
  .head-menu {
    height: 72px;
    display: flex;
    justify-content: flex-end;
    // justify-content: flex-start;
    // align-items: center;
    width: 100%;
    padding-right: 15px;
    // padding-left: 15px;
    padding-left: 125px;
    margin-right: auto;
    margin-left: auto;
    img {
      // height:44px;
      height: 83px;
      // width: 320px;
      // margin-left: 15px;
      // margin-right: 50px;
      margin-left: 34px;
      // margin-right: 30px;
      vertical-align: middle;
    }
    .logodoc {
      font-size: 40px;
      color: #ffffff;
      margin-left: 40px;
      margin-right: 60px;
    }
  }
  .head-login {
    .loginstr {
      color: #ffffff;
    }
  }
  .el-header {
    background: #f2f5f8;
    border-bottom: 1px solid #ddd;
    color: #444;
    height: 73px;
    line-height: 70px;
  }
  .header-box {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 10000;
    height: 72px;
  }
  .head-option {
    background-image:url('../assets/home/loginbg2.png');
    float: right;
    padding-right: 10px;
    // width: 100px;
    // width: 11%;
    // padding-left: 20px;
    // padding-left: 5px;
    // width: 14%;
    // width: 17%;
    font-size: 18px;
    color: #575B5F;
    .login {
      margin-left: 50px;
    }
  }
  .head-option-nologin {
    background-image:url('../assets/home/loginbg2.png');
    float: right;
    padding-right: 10px;
    width: 60%;
  }
  .logout,.logout>span {
    // width: 95px;
    height: 72px;
    // opacity: 0.62;
    // background: #D3D3D3;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    // font-family: Microsoft YaHei;
    font-weight: 400;
    color: #575B5F;
    cursor: pointer;
    img {
      margin-right: 11px;
      width: 22px;
      height: 22px;
    }
    i {
      margin-right: 8px;
    }
  }
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
  }

  .el-main {
    // background: #ffffff;
    padding: 0;
  }
  .el-select .el-input {
    width: 130px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .el-menu--horizontal>.el-menu-item{
    font-size: 18px;
    height: 72px;
    // border: none!important;
    border-right: 1px solid #d3d3d3!important;
  }
  .footer-box {
    height: 50px;
    background: #2B363F;
    width: 100%;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    color: #fff;
    font-size: 20px;
    // font-family: Poppins;
    text-align: center;
    flex-shrink: 0;
    margin-top: 20px;
  }
  /deep/.el-input__inner {
    border-radius: 1px;
  }
  /deep/.el-input-group__append {
    border-radius: 1px;
  }
  .headRow {
    width: 80%;
    margin: auto;
  }
  //新添加
  // .nav-menu ul {
  //   display: flex;
  //   list-style: none;
  //   gap: 20px;
  // }

  // .nav-menu li a {
  //   text-decoration: none;
  //   color: #333;
  // }

  /* 汉堡菜单按钮（默认隐藏） */
  .nav-toggle {
    display: none;
  }

  .nav-toggle-label {
    display: none;
    cursor: pointer;
    font-size: 24px;
    float: right;
  }

  .el-dropdown-menu__item, .el-menu-item {
    font-size: 16px;
    padding: 0 30px;
    display: flex;
    align-items: center;  /* 垂直居中 */
    justify-content: center;
  }

  /* 移动端样式（屏幕宽度 < 1366px） */
  @media (max-width: 1023px) {
    /* 隐藏导航栏 */
    .head-menu {
      display: none;
    }
    .nav-menu ul {
      display: none;
    }

    /* 显示汉堡菜单按钮 */
    .nav-toggle-label {
      display: block;
    }

    /* 点击汉堡菜单后显示导航栏 */
    .nav-toggle:checked ~ .nav-menu ul {
      display: block;
      position: absolute;
      top: 60px;
      left: 0;
      width: 100%;
      background: #fff;
      padding: 10px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    }
  }
  /* 移动端样式（屏幕宽度 < 1366px） */
  @media (max-width: 1365px) {
    // .head-menu{
    //   padding-left: 60px !important;
    // }
    .head-menu {
      height: 72px;
      display: flex;
      justify-content: flex-end;
      // justify-content: flex-start;
      // align-items: center;
      width: 100%;
      padding-right: 15px;
      // padding-left: 15px;
      padding-left: 60px !important;
      margin-right: auto;
      margin-left: auto;
      img {
        // height:44px;
        height: 83px;
        // width: 320px;
        // margin-left: 15px;
        // margin-right: 50px;
        margin-left: 34px;
        // margin-right: 30px;
        vertical-align: middle;
      }
      .logodoc {
        font-size: 40px;
        color: #ffffff;
        margin-left: 40px;
        margin-right: 60px;
      }
    }
    .el-dropdown-menu__item, .el-menu-item {
      font-size: 16px;
      padding: 0 15px;
      display: flex;
      align-items: center;  /* 垂直居中 */
      justify-content: center;
    }
    // .headRow {
    //   width: 80%;
    //   margin: auto;
    //   white-space: nowrap;
    //   overflow: hidden;
    // }
  }
  @media (max-width: 1366px) {
    .head-menu {
      height: 72px;
      display: flex;
      justify-content: flex-end;
      // justify-content: flex-start;
      // align-items: center;
      width: 100%;
      padding-right: 15px;
      // padding-left: 15px;
      padding-left: 90px !important;
      margin-right: auto;
      margin-left: auto;
      img {
        // height:44px;
        height: 83px;
        // width: 320px;
        // margin-left: 15px;
        // margin-right: 50px;
        margin-left: 34px;
        // margin-right: 30px;
        vertical-align: middle;
      }
      .logodoc {
        font-size: 40px;
        color: #ffffff;
        margin-left: 40px;
        margin-right: 60px;
      }
    }
  }
</style>
